import enUS from './enUS.json'
import thTH from './thTH.json'

export default {
  enUS,
  thTH,
}
